import LocalStorage from 'utils/local-storage';

export default LocalStorage;
